import { create } from 'zustand';

const DEFAULT_PAGE_SIZE = 10;

type ReleasesFilterType = {
    filter: {
        take: number;
        skip?: number;
        page: number;
        searchText: string;
    };
    setFilter: (filter: Partial<ReleasesFilterType['filter']>) => void;
    resetFilter: () => void;
};

const defaultState: ReleasesFilterType['filter'] = {
    take: DEFAULT_PAGE_SIZE,
    skip: 0,
    page: 0,
    searchText: ''
};

export const useReleasesFilter = create<ReleasesFilterType>((set) => ({
    filter: { ...defaultState },
    setFilter: (newFilter) => {
        set((state) => ({
            filter: {
                ...state.filter,
                ...newFilter,
            },
        }));
    },
    resetFilter: () => {
        set({
            filter: { ...defaultState },
        });
    },
}));
